"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@chakra-ui/react");
var _FaFileUpload = require("@react-icons/all-files/fa/FaFileUpload");
var _react2 = _interopRequireDefault(require("react"));
var _reactDropzone = require("react-dropzone");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @license
 *
 * SPDX-FileCopyrightText: Copyright © 2021 snek.at
 * SPDX-License-Identifier: EUPL-1.2
 *
 * Use of this source code is governed by an EUPL-1.2 license that can be found
 * in the LICENSE file at https://snek.at/license
 */

const UploadButton = ({
  onUpload,
  accept
}) => {
  const {
    getRootProps,
    getInputProps
  } = (0, _reactDropzone.useDropzone)({
    onDrop: onUpload,
    noDrag: true,
    accept,
    maxSize: 5000000
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...getRootProps(),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ...getInputProps()
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
      "aria-label": "",
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaFileUpload.FaFileUpload, {})
    })]
  });
};
var _default = UploadButton;
exports.default = _default;